module.exports = __webpack_public_path__ + "static/media/microBrite.edfb7924.png";